import React, { useContext } from 'react';
import { Link } from 'react-router';
import cn from 'classnames';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import { BreadcrumbContext } from './BreadcrumbProvider';

const BreadCrumbs = () => {
  const { breadCrumbs } = useContext(BreadcrumbContext);

  const isLast = (idx) => idx === breadCrumbs.length - 1;
  return (
    <div className="flex items-center">
      <ol className="flex list-none p-10">
        {breadCrumbs.map((breadCrumb, idx) => {
          const lastOne = isLast(idx);
          return (
            <li className="flex px-2" key={`${breadCrumbs.text}-${idx}`}>
              <Link
                to={breadCrumb.to}
                className={cn({
                  'text-blue-700': !lastOne,
                  'text-black': lastOne,
                  'cursor-default': lastOne,
                  'hover:text-black': lastOne,
                })}
              >
                {breadCrumb.text}
              </Link>
              {!lastOne && (
                <Icon id="chevron_right" className="ml-0.8 h-4 self-center" />
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default BreadCrumbs;
